import store from "../../Redux/store";
import { setEmissionCategory } from "./EmissionCategory.reducer";

export function saveListEmissionCategory(records) {
  store.dispatch(setEmissionCategory(records));
}
